import React from 'react'
import { StyledDiv } from './styled'

const VisuallyHidden = ({ children }) => <StyledDiv>{children}</StyledDiv>

export default VisuallyHidden
